/* eslint-disable */
import bi1_data_validation from '../base_i1_datavalidation'
import { RC, CR, AJRS } from '../base_i2_success_codes'
import base_i3_log from '../base_i3_logging'
import { ajax } from 'noquery-ajax'

function SendAccountNotificationRepsonse(user_email,notice_id, action) {
    return new Promise(function (resolve, reject) {
        var return_msg = "";
        var debug_data = [];
        var task_id = "p2s1t12_SendAccountNotificationRepsonse"
        var this_notice_id = null;
        var this_action = null;
        if (notice_id === null) {
            this_notice_id = "None";
        } else {
            this_notice_id = notice_id;
        }
        if (action === null) {
            this_action = "None";
        } else {
            this_action = action;
        }

        ajax({
        url: window.G_ajax_test_domain + '/console/p2s1t12-execute_notice_response',
        method: 'POST',
        dataType: "text",
        headers: {
            'Authorization': 'Bearer ' + G_firebase_auth.IV_id_token
        },
        data: {
            "user_email": user_email,
            "notice_id": this_notice_id,
            "action": this_action
         },
        success: function(result) {            
            resolve(JSON.stringify({ success: RC.success, return_msg: return_msg, debug_data: debug_data }));
        },
        error: function(error) {
            if (error.status === 401) {
                window.G_firebase_auth.bi5forceTokenRefresh();
            }
            return_msg += "ajax request failed"
            debug_data.push(JSON.stringify(error));
            reject(JSON.stringify({ success: RC.general_failure, return_msg: return_msg, debug_data: debug_data }));
        }
    })

});
};

export default SendAccountNotificationRepsonse


// WEBPACK FOOTER //
// ./src/watchdog_includes/legacy_calls/p2s1t12_SendAccountNotificationRepsonse.js